<template>
  <div class="container language-selection">
    <div v-for="lang in languages" :key="lang"
         class="flag-container"
         :class="{ 'selected' : language === lang }"
         @click="() => changeLanguage(lang)"
    >
      <img :src="getFlagImage(lang)" :alt="`${lang}-flag`" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'LanguageSelection',
  props: {
    languages: {
      type: Array,
      required: true
    },
    language: {
      type: String,
      default: 'en'
    }
  },
  created() {
    if (!this.languages.includes(this.language)) {
      this.changeLanguage(this.languages[0])
    }
  },
  methods: {
    changeLanguage(lang) {
      this.$emit('languageChange', lang)
    },
    getFlagImage(lang) {
      return require(`../../assets/flag/${lang}.svg`)
    }
  }
}
</script>
<style scoped lang="scss">
.container {
  width: 100%;
  position: relative;
  overflow: hidden;

  &.language-selection {
    display: flex;
    align-content: stretch;
    flex-direction: row;
    margin: 30px auto 0 auto;

    .flag-container {
      flex-grow: 1;
      padding: 10px;
      background: #f9f9f9;
      cursor: pointer;
      box-shadow: 0px -8px 6px 0px rgba(69, 69, 69, 0.2) inset;
      opacity: .5;

      &.selected {
        background: white;
        box-shadow: 2px 2px 8px 0 rgba(69, 69, 69, 0.20);
        opacity: 1;
      }

      img {
        width: 60px;
        height: 40px;
        margin-top: 4px;
      }
    }
  }
}
</style>
